import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AccountService } from '@infodocs/shared/services/account.service';
import { AuthService } from '@infodocs/shared/services/auth.service';
import { VerificationGuardService } from '@infodocs/shared/services/verification-guard.service';
import { UserpilotService } from '@infodocs/shared/services/userpilot.service';
import { FooterComponent } from '@infodocs/shared/components/footer/footer.component';
import { PrivateHeaderComponent } from '@infodocs/shared/components/header/private-header/private-header.component';

@Component({
	selector: 'app-private-pages-wrapper',
	imports: [
		PrivateHeaderComponent,
		RouterOutlet,
		FooterComponent,
	],
	templateUrl: './private-pages-wrapper.component.html',
	styleUrl: './private-pages-wrapper.component.scss',
})
export class PrivatePagesWrapperComponent implements OnInit {
	private readonly auth = inject(AuthService);
	private readonly userpilotService = inject(UserpilotService);
	protected readonly accountService = inject(AccountService);
	private readonly verificationGuard = inject(VerificationGuardService);

	public ngOnInit(): void {
		if (this.auth.currentUser()) {
			void this.loadUserpilotContext();
			this.verificationGuard.refreshVerificationLevel();
		}
	}

	private async loadUserpilotContext(): Promise<void> {
		const tasks: Promise<unknown>[] = [this.accountService.fetchAccount()];

		if (!this.auth.currentUser()?.creation_date) {
			tasks.push(firstValueFrom(this.auth.fetchUser()));
		}

		await Promise.allSettled(tasks);
		this.userpilotService.identify();
	}
}
